module.exports = __webpack_public_path__ + "static/coliving-bedroom-c0b1ae28d25878d405fe5f8e3b5d6e7e.jpg";